module.exports = __webpack_public_path__ + "img/14.4cbd1c4f.jpg";